import { Loader2 } from 'lucide-react';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Outlet } from 'react-router-dom';
import { LanguageSwitch } from '@/components/language-switch';
import { Button } from '@/components/ui/button';

/**
 * Chrome for the LOGGED-OUT catalogue: brand, language, and one way in.
 *
 * <CatalogChrome> hands anyone with a session to <AppLayout> instead, so this is
 * now reached only without one. It used to carry Profile and My applications
 * buttons for signed-in visitors; those are nav items in the rail now, and
 * keeping a second set here would be a second place to maintain them — the
 * drift the single nav model exists to prevent.
 */
export function PublicLayout() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-dvh flex-col bg-muted/20">
      <header className="sticky top-0 z-20 border-b bg-card">
        <div className="mx-auto flex h-16 max-w-[1400px] items-center justify-between gap-4 px-4 sm:px-6">
          <Link to="/opportunities" className="flex items-center gap-2">
            <span className="grid size-8 place-items-center rounded-lg bg-primary text-sm font-bold text-white">I</span>
            <span className="text-base font-semibold text-secondary-foreground">
              {/* AWARDS */ t('app.name')} <span className="font-medium text-muted-foreground">· {/* Ingazi */ t('app.org')}</span>
            </span>
          </Link>
          <div className="flex items-center gap-3">
            <LanguageSwitch />
            <Button asChild variant="brand" size="sm">
              <Link to="/login">{/* Sign in */ t('auth.signIn')}</Link>
            </Button>
          </div>
        </div>
      </header>

      <main className="mx-auto w-full max-w-[1400px] flex-1 px-4 py-8 sm:px-6">
        <Suspense fallback={<div className="grid place-items-center py-24"><Loader2 className="size-5 animate-spin text-primary" /></div>}>
          <Outlet />
        </Suspense>
      </main>

      <footer className="border-t py-6 text-center text-xs text-muted-foreground">
        {/* AWARDS */ t('app.name')} · {/* Ingazi */ t('app.org')} — {/* Manage awards and competitions */ t('app.tagline')}
      </footer>
    </div>
  );
}
